import script from "./policy-manage.vue?vue&type=script&lang=ts&setup=true"
export * from "./policy-manage.vue?vue&type=script&lang=ts&setup=true"

import "./policy-manage.vue?vue&type=style&index=0&id=6ab25ca5&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ab25ca5"]])

export default __exports__